<template>
  <div>
    <app-toolbar 
      :menu-items="menuItems" 
      :value="drawer"
       @updated="drawerState($event)"
    ></app-toolbar>
    <app-drawer
      :menu-items="menuItems"
      :secondary-items="secondaryItems"
      :value="drawer" 
      @updated="drawerState($event)"
    ></app-drawer>
  </div>
</template>

<script>
  import Drawer from './Drawer.vue'
  import Toolbar from './Toolbar.vue'

  export default {
    name: 'AppHeader',

    props: {
      menuItems: {
        type: Array,
        default: () => ([])
      },
      secondaryItems: {
        type: Array,
        default: () => ([])
      },
      tertiaryItems: {
        type: Array,
        default: () => ([])
      }
    },

    data: () => ({
      drawer: false,
      fulllogo: require('@/assets/conhome-full-logo.svg'),
      houseLogo: require('@/assets/conhome-house-logo.svg')
    }),

    computed: {
      logo() {
        return this.$vuetify.breakpoint.xs ? this.houseLogo : this.fulllogo
      }
    },

    methods: {
      drawerState(state) {
        this.drawer = state
      },
    },

    components: {
      'app-drawer': Drawer,
      'app-toolbar': Toolbar
    }
  }
</script>

<style lang="sass">
  .v-tab
    letter-spacing: 1px
  .v-tab.v-tab--icon
    min-width: 48px
</style>